import { render, staticRenderFns } from "./Syllabuses.vue?vue&type=template&id=6acfa42c&scoped=true&"
import script from "./Syllabuses.vue?vue&type=script&lang=js&"
export * from "./Syllabuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acfa42c",
  null
  
)

export default component.exports